import { QueryObject } from './queries'
import { CONDITION_ITEMS, Conditions } from '../constants/conditions'
import { fromEntries } from '../utils'

const buildRangeCondition = (name: any, from: any, to: any) => {
  if (
    (from === null || from === undefined) &&
    (to === null || to === undefined)
  ) {
    return {}
  }
  return {
    [name]: { from, to },
  }
}

const buildDateRangeCondition = (name: any, from: any, to: any) => {
  return buildRangeCondition(name, from, to)
}
const buildNumberRangeCondition = (name: any, from: any, to: any) => {
  return buildRangeCondition(name, Number(from) || null, Number(to) || null)
}

type ConditionEntity = [string, string[]]
const buildSelectedConditions = (rest: any) => {
  return fromEntries(
    Object.entries(rest)
      // field名がおかしいものは除外
      .filter(([name]) => CONDITION_ITEMS[name])
      // valueがおかしいものも除外
      .filter(
        (item): item is [string, string] =>
          typeof item[1] === 'string' && item[1] !== ''
      )
      // splitしたentityに変換
      .map(([name, value]): ConditionEntity => {
        return [name, value.split(',')]
      })
  )
}

// この関数ではあえてvalidateをしてない。
// validationはvalidate.tsに責務を移譲する
export function paramsOf(query: QueryObject): Conditions {
  let obj = {}
  const {
    totalFundingFrom,
    totalFundingTo,
    valuationFrom,
    valuationTo,
    employeesFrom,
    employeesTo,
    establishedFrom,
    establishedTo,
    ipoedFrom,
    ipoedTo,
    lastFundraisedFrom,
    lastFundraisedTo,
    ...rest
  } = query

  obj = {
    ...obj,
    ...buildNumberRangeCondition(
      'totalFunding',
      totalFundingFrom,
      totalFundingTo
    ),
    ...buildNumberRangeCondition('valuation', valuationFrom, valuationTo),
    ...buildNumberRangeCondition('employees', employeesFrom, employeesTo),
    ...buildDateRangeCondition('established', establishedFrom, establishedTo),
    ...buildDateRangeCondition('ipoed', ipoedFrom, ipoedTo),
    ...buildDateRangeCondition(
      'lastFundraised',
      lastFundraisedFrom,
      lastFundraisedTo
    ),
    ...buildSelectedConditions(rest),
  }
  return obj
}
